var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"slider",style:('background-image: -webkit-gradient(linear, 0% 0%, 100% 0%, color-stop(' +
        _vm.percent +
        ', ' +
        _vm.filledRail +
        '), color-stop(' +
        _vm.percent +
        ', ' +
        _vm.emptyRail +
        '));'),attrs:{"type":"range","min":_vm.min,"max":_vm.max,"step":_vm.step},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }